import React, {useEffect} from "react";
import {
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell,
    User,
    Chip,
    Link,
    Tooltip,
    getKeyValue, Button, ButtonGroup
} from "@nextui-org/react";
import {FaEdit, FaTrash, FaEye, FaPlusCircle,} from 'react-icons/fa'
import {getMachines, SaveUser} from "../API";
import {useNavigate} from "react-router-dom";

const statusColorMap = {
    active: "success",
    paused: "danger",
    vacation: "warning",
};

export default function Machines() {

    const navigate = useNavigate();
    const [machines, setMachines] = React.useState([]);
    const columns = [
        {name: "CODIGO", uid: "idmachine"},
        {name: "NOMBRE", uid: "name"},
        {name: "DESCRIPCION", uid: "desc"},
        {name: "TEMP.", uid: "temp"},
        {name: "HUM.", uid: "hum"},
        {name: "FILAS", uid: "rows"},
        {name: "COLUMNAS", uid: "columns"},
        {name: "CELDAS", uid: "cells"},
        {name: "ACCIONES", uid: "actions"},
    ];

    useEffect(() => {
        Starting();
    }, []);

    async function Starting() {
        const m = await getMachines();
        setMachines(m);
    }

    function GoToDetails(data){
        navigate("/dashboard/machine-details", { state: {data} });
    }

    function NewMachine(){
        navigate("/dashboard/machine-details");
    }

    async function Save(e){
        e.preventDefault();
        // setisLoading(true);
        // const res= await SaveUser(userdata);
        // setisLoading(false);
    }

    const renderCell = React.useCallback((machine, columnKey) => {
        const cellValue = machine[columnKey];
        switch (columnKey) {
            case "actions":
                return (
                    <div className="relative flex items-center gap-2">
                        {/*<Button onClick={()=>GoToDetails(machine)} color="transparent" isIconOnly>*/}
                        {/*    <Tooltip content="Detalles">*/}
                        {/*      <span className="text-lg text-default-400 cursor-pointer active:opacity-50">*/}
                        {/*        <FaEye/>*/}
                        {/*      </span>*/}
                        {/*    </Tooltip>*/}
                        {/*</Button>*/}
                        <Button onClick={()=>GoToDetails(machine)} color="transparent" isIconOnly>
                            <Tooltip content="Editar maquina">
                                  <span className="text-lg text-default-400 cursor-pointer active:opacity-50">
                                    <FaEdit/>
                                  </span>
                            </Tooltip>
                        </Button>
                        {/*<Tooltip color="danger" content="Borrar maquina">*/}
                        {/*      <span className="text-lg text-danger cursor-pointer active:opacity-50">*/}
                        {/*        <FaTrash/>*/}
                        {/*      </span>*/}
                        {/*</Tooltip>*/}
                    </div>
                );

            case 'idmachine':
                return(
                  <Chip color="success">{cellValue}</Chip>
                );

            case 'temp':
                return(
                    <Chip color="danger">{cellValue} °C</Chip>
                );

            case 'hum':
                return(
                    <Chip color="primary">{cellValue}%</Chip>
                );

            default:
                return cellValue;
        }
    }, []);

    return (
        <div className="container flex flex-col">
            <h1 className="text-center pb-2 text-2xl">Maquinas</h1>
            <div>
                <ButtonGroup className="p-3">
                    <Button onClick={NewMachine}><FaPlusCircle className="text-success"/> Maquina</Button>
                </ButtonGroup>
            </div>

            <Table aria-label="Maquinas">
                <TableHeader columns={columns}>
                    {(column) => (
                        <TableColumn key={column.uid} align={column.uid === "actions" ? "center" : "start"}>
                            {column.name}
                        </TableColumn>
                    )}
                </TableHeader>
                <TableBody items={machines}>
                    {(item) => (
                        <TableRow key={item.idmachine}>
                            {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>

    );
}
